import { CountryCode } from "../types/kpiConfigTypes";
import getValidKpiVisibility from "./kpiConfig";

export function getKpis(country: CountryCode, moduleName: string): string[] {
  const module = getModule(country, moduleName);
  return module ? module.kpis : [];
}

export function hasKpis(country: CountryCode, moduleName: string): boolean {
  return getKpis(country, moduleName).length > 0;
}

export function kpiExists(country: CountryCode, moduleName: string, kpiName: string): boolean {
  return getKpis(country, moduleName).some(
    (k) => k.toLowerCase() === kpiName.toLowerCase()
  );
}

export function moduleExists(country: CountryCode, moduleName: string): boolean {
  return getModule(country, moduleName) !== null;
}

export function getModule(country: CountryCode, moduleName: string) {
  const countryConfig = getValidKpiVisibility()[country];
  return countryConfig?.modules.find((m) => m.name.toLowerCase() === moduleName.toLowerCase() ) || null;
}